// Parse the same restricted grammar as the server; never execute a formula as JavaScript.
export function parseFormula (source) {
  const text = String(source || '').trim().replace(/^(网格数|单元数)\s*=(?!=)/, '').replace(/（/g, '(').replace(/）/g, ')').replace(/，/g, ',').replace(/≥/g, '>=').replace(/≤/g, '<=')
  if (!text) return null
  let index = 0
  function space () { while (/\s/.test(text[index] || '') && index < text.length) index++ }
  function take (token) { space(); if (text.slice(index, index + token.length) !== token) return false; index += token.length; return true }
  function primary () {
    space()
    if (take('(')) { const value = expression(); if (!take(')')) throw new Error('括号不匹配'); return value }
    const number = text.slice(index).match(/^(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?/)
    if (number) { index += number[0].length; return { kind: 'number', value: number[0] } }
    const identifier = text.slice(index).match(/^[A-Za-z_\u3400-\u9fff][A-Za-z0-9_\u3400-\u9fff.]*/)
    if (!identifier) throw new Error('存在无法识别的内容')
    index += identifier[0].length
    if (!take('(')) return { kind: 'variable', key: identifier[0] }
    const args = []
    if (!take(')')) { do { args.push(expression()) } while (take(',')); if (!take(')')) throw new Error('括号不匹配') }
    if (!['min', 'max', 'abs', 'round', 'floor', 'ceil', 'if'].includes(identifier[0].toLowerCase())) throw new Error('旧公式中包含当前编辑器不支持的函数')
    return { kind: 'call', name: identifier[0].toLowerCase(), args }
  }
  function factor () {
    for (const op of ['+', '-', '!']) if (take(op)) return { kind: 'unary', op, child: factor() }
    const left = primary(); return take('^') ? { kind: 'binary', op: '^', left, right: factor() } : left
  }
  function binary (next, operators) {
    let left = next()
    while (true) {
      let found = ''
      for (const operator of operators) if (take(operator)) { found = operator; break }
      if (!found) return left
      left = { kind: 'binary', op: found, left, right: next() }
    }
  }
  const term = () => binary(factor, ['*', '/', '%'])
  const arithmetic = () => binary(term, ['+', '-'])
  const compare = () => binary(arithmetic, ['>=', '<=', '==', '!=', '>', '<'])
  const and = () => binary(compare, ['&&'])
  const expression = () => binary(and, ['||'])
  const result = expression(); space()
  if (index !== text.length) throw new Error('存在无法识别的内容')
  return result
}

export function formulaText (node) {
  if (!node) throw new Error('请选择计算内容')
  if (node.kind === 'number') {
    if (String(node.value).trim() === '' || !Number.isFinite(Number(node.value))) throw new Error('请填写有效的数值')
    return String(node.value)
  }
  if (node.kind === 'variable') { if (!node.key) throw new Error('请选择指标参数'); return node.key }
  if (node.kind === 'unary') return '(' + node.op + formulaText(node.child) + ')'
  if (node.kind === 'binary') {
    if (['/', '%'].includes(node.op) && node.right.kind === 'number' && Number(node.right.value) === 0) throw new Error('除数不能为0')
    if (node.op === 'safeDivide') { const left = formulaText(node.left), right = formulaText(node.right); return 'if((' + right + ') == 0, 0, (' + left + ') / (' + right + '))' }
    return '(' + formulaText(node.left) + ' ' + node.op + ' ' + formulaText(node.right) + ')'
  }
  if (node.kind === 'call') return node.name + '(' + node.args.map(formulaText).join(', ') + ')'
  throw new Error('计算方式不完整')
}

export function formulaDescription (node, name) {
  if (!node) return '尚未配置'
  if (node.kind === 'number') return String(node.value)
  if (node.kind === 'variable') return name(node.key)
  if (node.kind === 'unary') return (node.op === '-' ? '负' : node.op === '!' ? '非' : '正') + formulaDescription(node.child, name)
  if (node.kind === 'binary') {
    const op = { '*': '×', '/': '÷', safeDivide: '安全除以（除数为0时结果为0）', '==': '＝', '!=': '≠', '>=': '≥', '<=': '≤', '&&': '且', '||': '或', '^': '的次方', '%': '取余' }[node.op] || node.op
    return '(' + formulaDescription(node.left, name) + ' ' + op + ' ' + formulaDescription(node.right, name) + ')'
  }
  if (node.name === 'min' && node.args.length === 2) {
    for (const [data, limit] of [[node.args[0], node.args[1]], [node.args[1], node.args[0]]]) {
      const n = limit?.kind === 'number' ? Number(limit.value) : limit?.kind === 'unary' && ['+', '-'].includes(limit.op) && limit.child?.kind === 'number' ? Number(limit.child.value) * (limit.op === '-' ? -1 : 1) : NaN
      if (data?.kind === 'variable' && Number.isFinite(n)) return name(data.key) + '（上限 ' + n + '）'
    }
  }
  const fn = { min: '取较小值', max: '取较大值', abs: '取绝对值', round: '四舍五入', floor: '向下取整', ceil: '向上取整', if: '条件判断' }[node.name] || node.name
  return fn + '（' + node.args.map(arg => formulaDescription(arg, name)).join('，') + '）'
}
